import {
  AllowedFilterFields,
  FilterPolicy,
  FilterPolicyRule,
} from "@/api/ticket-event/ticket-event.model";
import { ExploreInteractionRow } from "@/v2/entities/explore/Explore.model";

function ruleCheck(
  rule: FilterPolicyRule,
  ticket: ExploreInteractionRow & { topicId: string }
) {
  switch (rule.field) {
    case AllowedFilterFields.GRADUAL_ROLLOUT:
    case AllowedFilterFields.INLINE_ATTACHMENT:
    case AllowedFilterFields.REGULAR_ATTACHMENT:
    case AllowedFilterFields.BRAND:
    case AllowedFilterFields.TICKET_FIELDS:
      // currently not supported
      return true;

    case AllowedFilterFields.CHANNEL:
      if (rule.operator === "is") {
        return rule.value.includes(ticket.channel);
      } else {
        return !rule.value.includes(ticket.channel);
      }
    case AllowedFilterFields.TAG:
      if (rule.operator === "is") {
        return ticket.tags?.some((tag) => rule.value.includes(tag));
      } else {
        return !ticket.tags?.some((tag) => rule.value.includes(tag));
      }
    case AllowedFilterFields.TOPIC:
      if (rule.operator === "is") {
        return rule.value.includes(ticket.topicId);
      } else {
        return !rule.value.includes(ticket.topicId);
      }
    case AllowedFilterFields.EMAIL:
      const ticketEmail = ticket.tenantUser || "";

      if (rule.operator === "is") {
        return rule.value.includes(ticketEmail);
      } else if (rule.operator === "is_not") {
        return !rule.value.includes(ticketEmail);
      } else if (rule.operator === "contains") {
        return rule.value.some((val) => ticketEmail.toLowerCase().includes(val.toLowerCase()));
      } else if (rule.operator === "not_contains") {
        return !rule.value.some((val) => ticketEmail.toLowerCase().includes(val.toLowerCase()));
      }
      return false;
    default:
      // Handle all metadata fields that start with "metadata."
      if (typeof rule.field === "string" && rule.field.startsWith("metadata.")) {
        const metadataKey = rule.field.substring(9); // Remove "metadata." prefix
        const ticketMetadataValue = (ticket as any).metadata?.[metadataKey];
        
        if (ticketMetadataValue === undefined || ticketMetadataValue === null) {
          return false;
        }

        // Handle numeric comparisons for ARR fields
        if (rule.field === AllowedFilterFields.CUSTOM_ARR || rule.field === AllowedFilterFields.CUSTOM_ARR_GLOBAL) {
          const ticketNum = Number(ticketMetadataValue);
          const ruleNum = Number(rule.value[0]);
          
          if (isNaN(ticketNum) || isNaN(ruleNum)) {
            return false;
          }

          if (rule.operator === "gt") {
            return ticketNum > ruleNum;
          } else if (rule.operator === "lt") {
            return ticketNum < ruleNum;
          }
          return false;
        }

        // Handle string comparisons for all other metadata fields
        const ticketValueStr = String(ticketMetadataValue).toLowerCase();
        const ruleValueStr = String(rule.value[0] || "").toLowerCase();

        if (rule.operator === "is") {
          return ticketValueStr === ruleValueStr;
        } else if (rule.operator === "is_not") {
          return ticketValueStr !== ruleValueStr;
        } else if (rule.operator === "contains") {
          return ticketValueStr.includes(ruleValueStr);
        } else if (rule.operator === "not_contains") {
          return !ticketValueStr.includes(ruleValueStr);
        }
        return false;
      }
      return false;
  }
}

export function isTicketIncludedInFilterPolicy(
  ticket: ExploreInteractionRow & { topicId: string },
  filterPolicy: FilterPolicy
) {
  return filterPolicy.some(function (policy) {
    if (policy.combinator === "and") {
      return policy.rules.every(function (rule) {
        return ruleCheck(rule, ticket);
      });
    } else {
      return policy.rules.some(function (rule) {
        return ruleCheck(rule, ticket);
      });
    }
  });
}